export default "__VITE_ASSET__dO0tWthX__"